<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-gears"></i> Gerenciar Andamento </h1>
          </div>
        </div>
      </div>


      <div class="container">        
        <hr/>
        <div class="row">

          <div class="col-md-3 col-6 mt-2">
            <div class="card" @click="goToExpiredSignatures()">
              <div class="card-body">
                <h5 class="card-title"><span class="badge badge-pill badge-light p-2">{{signature_expiring}} </span> </h5>
                <a href="#" class="card-text">Vencendo no mês </a>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-6 mt-2">
           <div class="card" @click="goToSignatures('1')">
              <div class="card-body">
                <h5 class="card-title"><span class="badge badge-pill badge-light p-2">{{month_signature}}</span></h5>
                <a href="#" class="card-text">Assinaturas no mês</a>
              </div>
            </div>
          </div>

          <div class="col-md-3 col-6 mt-2">
            <div class="card" @click="goToSignatures('2')">
              <div class="card-body">
                <h5 class="card-title"><span class="badge badge-pill badge-light p-2">{{month_renews}}</span></h5>
                <a href="#" class="card-text">Renovações no mês</a>
              </div>
            </div>
          </div>

           <div class="col-md-3 col-6 mt-2">
            <div class="card" @click="goToSignatures('3')">
              <div class="card-body">
                <h5 class="card-title"><span class="badge badge-pill badge-light p-2">{{month_orders}}</span></h5>
                <a href="#" class="card-text">Compras no mês</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>


    <div class="container">
      <div class="row">
       <div class="col-9">
         <div class="input-group" style="margin-bottom: 10px">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input type="text" class="form-control" id="myInput" @keyup.enter="getsignatures(1)" v-model="search" placeholder="Filtrar..." />

            <div class="input-group-append">
              <span class="input-group-text" @click="getsignatures(1)"><i class="fa fa-refresh"></i></span>
            </div>
         </div>
        </div>
        <div class="col-3">

          <select v-on:change="getsignatures(1)" class="form-control" v-model="status">
            <option value="">Todos</option>
            <option value="1">Download liberado</option>
            <option value="5">Ativa</option>
            <option value="2">Aguardando envio</option>
            <option value="3">Enviado</option>
            <option value="4">Vencida</option>
          </select>

        </div>

        <div class="col-12">

          <table class="table table-bordered table-bsignatureed" style="background: white">
            <thead>
            <tr>
              <th width="20">ID</th>
              <th width="20">Pedido</th>
              <th width="400">Usuário</th>
              <th>Publicação</th>
              <th width="200">Status</th>
              <th width="100">Vencimento</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="signature in signatures" v-bind:key="signature.id">
              <td class="text-center"><a href="javascript:;" @click="redirectURL('/admin/signature/'+signature.id)">{{signature.id}}</a> </td>
              <td class="text-center">#{{signature.order.id}}</td>
              <td>
                <small v-if="signature.profile.person_or_company">{{signature.profile.company_name | truncate(50) }}</small>
                <small v-else>{{signature.profile.name | truncate(50) }}</small>
              </td>
              <td><small>{{ signature.publication.name }}</small></td>
              <td style="position: relative">
<!--                <i v-show="!signature.track_code && signature.status.id == 3" style="color: #ff0000; top: 16px; left: 160px;" class="fa-li fa fa-exclamation-triangle"></i>-->
                <span :inner-html.prop="signature.status.id | nameStatusPublication"></span>
              </td>
              <td class="text-center">
                <small v-if="signature.publication.is_signature">
                {{ signature.due | formatDate }}
                </small>
                <small v-else>
                  Compra Única
                </small>
              </td>
            </tr>
            <tr v-show="!signatures.length"><td colspan="6" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
          <div class="pagination pagination-medium pagination-right">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getsignatures(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getsignatures(next)">Próxima</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <footer-admin/>
  </div>
</template>

<script>
  import statistic from "../../api/statistic"
  import signature from "../../api/signature"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import moment from 'moment'

  export default {
    name: "AdminSignatures",
    mixins: [mixins],
    data () {
      return {
        signatures: [],
        status: "",
        page: 1,        
        signature_expiring: 0, 
        month_signature: 0, 
        month_renews: 0, 
        month_orders: 0, 
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
    },
    methods: {

      goToExpiredSignatures(){
       //this.$router.push('expired_signatures'); 
       this.$router.push({ name: 'expired_signatures' })
      },

      goToSignatures(param){
       //this.$router.push('expired_signatures'); 
       this.$router.push({ name: 'report_signatures', params: {status_type: param} })
      },

      getsignaturesStatus(status){
          this.status = status;
          this.getsignatures(1);
      },

      getsignatures(page){			
			
          this.page = page
        signature.list(this.page, this.search, this.status).then((response)  =>  {          
          this.signatures = response.data.results
          this.treatPagination(page, response.data.count, response.data.pages)          

        })
      },

      getStatistic(){

     
          const firstDay = moment().startOf('month').format('YYYY-MM-DD');
          const lastDay   = moment().endOf('month').format('YYYY-MM-DD');

          statistic.get_shipping_waiting(2).then((response)  =>  {  
            this.shipping_waiting = response.data.count;
          })

          //this.signature_expiring = statistic.get_signature_expiring('2022-02-22', '2022-03-04');
          statistic.get_signature_expiring(firstDay,lastDay).then((response)  =>  {          
            this.signature_expiring = response.data.length;
          })

          statistic.get_month_count(firstDay, lastDay, 1).then((response)  =>  {               
            this.month_signature = response.data;          
          })

          statistic.get_month_count(firstDay, lastDay, 2).then((response)  =>  {               
            this.month_renews = response.data;
          })

          statistic.get_month_count(firstDay, lastDay, 3).then((response)  =>  {               
            this.month_orders = response.data;
          })

          //this.sales_today = statistic.get_sales_today();
          //this.signature_today = statistic.get_signature_today();

          //statistic.get_shipping_waiting().then((response)  =>  {          
          //console.log("aqui>>")    
          //console.log(response)    
        //})
      }

      

    },
    activated(){      
      this.getStatistic();
      this.getsignatures(this.page);
    },
    mounted(){      
      this.getsignatures(this.page)
    }
  }
</script>

<style scoped>

</style>
